import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes";


// import {
//   validaSoloNumero,
//   validaNumeroTelefono,
//   validaEmail,
// } from "../../../util/varios";
// import axios from "axios";
import moment from "moment";
import { Dimmer } from "../../spinner";

export const ImpSectorEjidos = (props) => {

  const [titulo1, setTitulo1] = useState();
  const [titulo2, setTitulo2] = useState();
  const [titulo3, setTitulo3] = useState();

  useEffect(()=>{
    if (props.tabla === 6) {
      setTitulo1('Impresion Contribuyentes de rentas Inmobiliarias');
      setTitulo2('Contribuyentes de rentas Inmoiliarias');
      setTitulo3('Inscritos al Dia:')
    }

    if (props.tabla === 7) {
      setTitulo1('Contribuyentes de rentas Inmobiliarias Contratos Vencidos');
      setTitulo2('Contribuyentes Con Contratos Vencidos');
      setTitulo3('Contratos Vencidos en Fecha:')
    }

    if (props.tabla === 8) {
      setTitulo1('Contribuyentes de Rentas Inmobiliarias con Deudas');
      setTitulo2('Contribuyentes Con Deudas');
      setTitulo3('Deuda al Dia:')
    }
  },[])
  /*  variables de estados */

  let op = require("../../../../src/modulos/datos");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  // const [mostrar2, setMostrar2] = useState(false);
  // const [mostrar3, setMostrar3] = useState(false);
  const [msg2, setMsg2] = useState();
  const [activate, setActivate] = useState(false);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  // const [contar, setContar] = useState(0);
  const [contar1, setContar1] = useState(0);
  // const [contar2, setContar2] = useState(0);
  // const [tecla, setTecla] = useState();
  const [anio, setAnio] = useState();
  const [visibleF, setVisibleF] = useState("hidden");
  // const [visibleA, setVisibleA] = useState("hidden");
  // const radioTodasFecha = useRef();
  // const radioSeleccionarFecha = useRef();

  const cmbTipCont = useRef("");
  // const cmbAnio = useRef("");
  // const txtSectorDesde = useRef();
  // const txtSectorHasta = useRef();
  const txtFechaDesde = useRef();
  const txtFechaHasta = useRef();
  // const chkActivo = useRef();
  // const chkInactivo = useRef();
  // const chkClausurado = useRef();
  // const chkFiscal = useRef();
  // const chkNotificado = useRef();
  // const chkDepLegal = useRef();
  // const chkExonerado = useRef();
  // const chkRevCerrado = useRef();
  // const txtCodActividad = useRef();
  // const txtDescripcionActi = useRef();
  const txtTodo = useRef();
  const txtTipo = useRef();
  const txtTipoRenta = useRef();
  const txtFecha = useRef();
  const [tipo, setTipo] = useState();

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    var nanio = [];
    var aini = parseInt(obj.anioactu) - 7;
    var afin = parseInt(obj.anioactu);
    for (let i = 1; i <= afin - aini; i++) {
      nanio.push({ anio: aini + i });
    }
    setAnio(nanio);
  }, []);

  const handleCloseSi = () => {
    setMostrar1(false);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputFechaDesde") {
        if (txtFechaDesde.current.value === "") {
          setTitulo("Error");
          setMsg("Fecha Invalida");
          setMostrar(true);
          txtFechaDesde.current.value = fechaSistema;
        } else if (txtFechaDesde.current.value > txtFechaHasta.current.value) {
          setTitulo("Error");
          setMsg("La fecha de inicio no puede ser superior a la fecha de fin.");
          setMostrar(true);
          //txtFechaDesde.current.value = txtFechaHasta.current.value;
        } else {
          txtFechaHasta.current.focus();
        }
      } else if (event.target.id === "inputFechaHasta") {
        if (txtFechaHasta.current.value === "") {
          setTitulo("Error");
          setMsg("Fecha Invalida");
          setMostrar(true);
          txtFechaHasta.current.value = fechaSistema;
        } else if (txtFechaDesde.current.value > txtFechaHasta.current.value) {
          setTitulo("Error");
          setMsg("La fecha de fin no puede ser inferior a la fecha de inicio.");
          setMostrar(true);
          //txtFechaHasta.current.value = txtFechaDesde.current.value;
        } else {
          if (props.tiporep === "1") {
            cmbTipCont.current.focus();
          } else if (props.tiporep === "2") {
            btnAcepta.current.focus();
          }
        }
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputFechaDesde") {
        if (txtFechaDesde.current.value === "") {
          setTitulo("Error");
          setMsg("Fecha Invalida");
          setMostrar(true);
          txtFechaDesde.current.value = fechaSistema;
        } else if (txtFechaDesde.current.value > txtFechaHasta.current.value) {
          setTitulo("Error");
          setMsg("La fecha de inicio no puede ser superior a la fecha de fin.");
          setMostrar(true);
          //txtFechaDesde.current.value = txtFechaHasta.current.value;
        }
      } else if (event.target.id === "inputFechaHasta") {
        if (txtFechaHasta.current.value === "") {
          setTitulo("Error");
          setMsg("Fecha Invalida");
          setMostrar(true);
          txtFechaHasta.current.value = fechaSistema;
        } else if (txtFechaDesde.current.value > txtFechaHasta.current.value) {
          setTitulo("Error");
          setMsg("La fecha de inicio no puede ser superior a la fecha de fin.");
          setMostrar(true);
          //txtFechaDesde.current.value = txtFechaHasta.current.value;
        }
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const handleChangeRadioFecha = (event) => {
    if (event.target.value === "1") {
      setVisibleF("hidden");
    } else if (event.target.value === "2") {
      setVisibleF("visible");
    }
  };

  const cancelar = () => {
    blanquear()
  };

  const blanquear = () =>{
    setVisibleF("hidden");
    txtTodo.current.checked = true;
 
    txtTipoRenta.current.value = '';
    txtFecha.current.value = '';
  }

  const salir = (e) => {
    e.preventDefault();
    props.setShow(false);
    blanquear()
  };

  const imprimirReporte = () => {
    var sigue = true;

    if (txtTodo.current.checked) {
      if (txtFecha.current.value === "") {
        setTitulo("Error");
        setMsg("Debe Ingresar Una Fecha");
        setMostrar(true);
        sigue = false;
        txtFecha.current.focus();
      }
    } else if (txtTodo.current.checked) {
      if (txtFecha.current.value === "") {
        setTitulo("Error");
        setMsg("Debe Ingresar Una Fecha");
        sigue = false;
        txtFecha.current.focus();
      } else if (tipo === "") {
        setTitulo("Error");
        setMsg("Debe SEleccionar un Tipo de Renta");
        sigue = false;
        txtTipoRenta.current.focus();
      }
    }

    if (sigue) {
      var reporte = "";
      var sql = "";
      // var sql1 = "";
      var sql2 = "";
      var sql3 = "";
      var fech = "";

      if (props.tabla === 6) {
        console.log("estamos en 1");

        reporte = "ListRentasContrib";

        if (txtTodo.current.checked) {
          fech =
            " fechainicio <= '" +
            moment.utc(txtFecha.current.value).format("YYYY-MM-DD") +
            "'";

          sql = "true" + " and " + fech;

          sql2 = "por Tipo de Rentas Inmobiliarias";
        } else if (txtTipo.current.checked) {
          fech =
            " fechainicio <= '" +
            moment.utc(txtFecha.current.value).format("YYYY-MM-DD") +
            "'";

          sql = "Descripcion =" + "'" + tipo.trim() + "'";

          sql2 = "CLASIFICADO POR" + " " + "'" + tipo.trim() + "'";
        }

        window.open(
          op.reportes + "/rentasinmobiliarias?" + "reporte=" + reporte + "&sql=" + sql + "&sql2=" + sql2,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      } else if (props.tabla === 7) {
        console.log("estamos en 2");

        reporte = "ListRentasVencidas";

        if (txtTodo.current.checked) {
          fech = moment.utc(txtFecha.current.value).format("YYYY-MM-DD");

          sql = "fechaculminacion <=" + "'" + fech + "'";

          sql2 = " ";
        } else if (txtTipo.current.checked) {
          fech = moment.utc(txtFecha.current.value).format("YYYY-MM-DD");

          sql =
            "descripcion =" +
            "'" +
            tipo.trim() +
            "'" +
            "and fechaculminacion <=" +
            "'" +
            fech +
            "'";

          sql2 = "CLASIFICADO POR" + " " + "'" + tipo.trim() + "'";
        }

        window.open(
          op.reportes + "/rentasinmobiliarias?" + "reporte=" + reporte + "&sql=" + sql + "&sql2=" + sql2,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      } else if (props.tabla === 8) {
        console.log("estamos en 3");

        reporte = "ListRentasDeudas";

        fech = moment.utc(txtFecha.current.value).format("YYYY-MM-DD");

        if (txtTodo.current.checked) {
          sql = "FCHPAGO ISNULL OR FCHPAGO <='" + fech + "'";

          sql2 = " ";

          sql3 = "TRUE ";
        } else if (txtTipo.current.checked) {
          sql = "FCHPAGO ISNULL OR FCHPAGO <='" + fech + "'";

          sql2 = "CLASIFICADO POR" + " " + "'" + tipo.trim() + "'";

          sql3 = "descripcion =" + "'" + tipo.trim() + "'";
        }

        window.open(
          op.reportes + "/rentasinmobiliarias?" +
            "reporte=" +
            reporte +
            "&sql=" +
            sql +
            "&sql2=" +
            sql2 +
            "&sql3=" +
            sql3 +
            "&fecha=" +
            fech,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      }
    }
  };

  const onChange = (event) => {
    let a = event.target;
    if (a.name === "inputDate") {
      console.log(moment.utc(a.value).format("DD/MM/YYYY"));
    } else if (a.name === "selectTipo") {
      setTipo(a.value);
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setContar1(0);
        setVisibleF("hidden");
      }}
    >
      <Modal.Header className="azulGradiant">
        <Modal.Title style={{ color: "#fff" }}>{titulo1}</Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={salir}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ color: "rgb(106, 115, 123)" }}>
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <MensajeSiNo
          titulo={titulo2}
          mensaje={msg2}
          show={mostrar1}
          onHideSi={handleCloseSi}
          onHideNo={handleCloseNo}
        />
        <Dimmer active={activate} >
        </Dimmer>
        <div
          className="row col-md-12 mx-auto"
          style={{
             overflow: "auto",
            fontFamily: "Times New Roman, Times, serif",
            fontSize: "15px",
          }}
        >
          <div className="col-md-12 mx-auto py-2">
            <h2 className="text-center">{titulo2}</h2>
          </div>

          <div className="row col-md-6">
           
              <label className="col">
                Buscar por:
              </label>
      

            <div class="form-check col">
              <input
               className="form-check-input"
               ref={txtTodo}
               type="radio"
               defaultChecked
               name="radioDeclara"
               value="1"
               id="radioSi"
               onChange={handleChangeRadioFecha}
              />
              <label class="form-check-label" for="flexRadioDefault1">
              Todo
              </label>
            </div>

            <div class="form-check col">
              <input
                 className="form-check-input"
                 ref={txtTipo}
                 type="radio"
                 name="radioDeclara"
                 value="2"
                 id="radioSi"
                 onChange={handleChangeRadioFecha}
              />
              <label class="form-check-label" for="flexRadioDefault1">
              Tipo Renta
              </label>
            </div>
          </div>
          <div
            className="input-group input-group-sm col-md-6"
            style={{
              visibility: visibleF,
            }}
          >
            <div className="input-group-prepend px-0" style={{ height: 27 }}>
              <span className="input-group-text w-100">Tipo de Renta:</span>
            </div>
            <select
              ref={txtTipoRenta}
              className="form-control form-control-sm"
              id="selectTipo"
              name="selectTipo"
              onChange={onChange}
            >
              <option value={""}>...</option>
              {props.rentas &&
                props.rentas.map((item, index) => (
                  <option key={index} value={item.descripcion}>
                    
                    {item.descripcion}
                  </option>
                ))}
            </select>
          </div>

          <div className="col-md-7"></div>

          <div
            className="input-group input-group-sm col-md-5 align-self-start py-2"
            style={{ height: 27}}
          >
            <div className="input-group-prepend">
              <span className="input-group-text">{titulo3}</span>
            </div>
            <input
              type="date"
              className="form-control form-control-sm"
              ref={txtFecha}
              defaultValue={moment.utc(fechaSistema).format('YYYY-MM-DD')}
              id="inputDate"
              name="inputDate"
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
              onChange={onChange}
            />
          </div>

          <div className="col-md-1"></div>

         
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          onClick={imprimirReporte}
          className="btn btn-sm btn-primary rounded-pill col-md-2"
        >
          <i className="fas fa-print"> Imprimir</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-secondary rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
        <button
          ref={btnSalir}
          onClick={salir}
          className="btn btn-sm btn-danger rounded-pill col-md-2"
        >
          <i className="fa fa-sign-out"> Salir</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};
